import type { GetStatsInput, StatCreateDto, StatDto, StatUpdateDto } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StatService {
  apiName = 'Analysis';

  create = (input: StatCreateDto) =>
    this.restService.request<any, StatDto>({
      method: 'POST',
      url: `/api/analysis/stats`,
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/analysis/stats/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, StatDto>({
      method: 'GET',
      url: `/api/analysis/stats/${id}`,
    },
    { apiName: this.apiName });

  getList = (input: GetStatsInput) =>
    this.restService.request<any, PagedResultDto<StatDto>>({
      method: 'GET',
      url: `/api/analysis/stats`,
      params: { filterText: input.filterText, viewsCountMin: input.viewsCountMin, viewsCountMax: input.viewsCountMax, statDateMin: input.statDateMin, statDateMax: input.statDateMax, userCountMin: input.userCountMin, userCountMax: input.userCountMax, assetCountMin: input.assetCountMin, assetCountMax: input.assetCountMax, linkCountMin: input.linkCountMin, linkCountMax: input.linkCountMax, scenesCountMin: input.scenesCountMin, scenesCountMax: input.scenesCountMax, storiesCountMin: input.storiesCountMin, storiesCountMax: input.storiesCountMax, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  update = (id: string, input: StatUpdateDto) =>
    this.restService.request<any, StatDto>({
      method: 'PUT',
      url: `/api/analysis/stats/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
